"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }/* Which files the Forms import takes, what it says about the rest, and how a
 * fillable PDF's widgets become fields. */


 const MAX_PAGES = 10; exports.MAX_PAGES = MAX_PAGES
// The server's own cap (bloom.FormMaxFields).
const MAX_FIELDS = 400



const extensionOf = (name) => _nullishCoalesce(_optionalChain([name, 'access', _ => _.toLowerCase, 'call', _2 => _2(), 'access', _3 => _3.match, 'call', _4 => _4(/\.([a-z0-9]+)$/), 'optionalAccess', _5 => _5[1]]), () => ( ''))

// Any image is tried; one the browser can't decode is refused then.
const IMAGE_EXTENSIONS = new Set(['jpg', 'jpeg', 'png', 'heic', 'heif', 'webp', 'gif', 'avif', 'bmp'])
const WORD_EXTENSIONS = new Set(['doc', 'docx'])

/* A file the import takes, or why not. */
 const importKind = (file) => {
  const ext = extensionOf(file.name)
  if (ext === 'pdf' || file.type === 'application/pdf') return { kind: 'pdf' }
  if (IMAGE_EXTENSIONS.has(ext) || file.type.startsWith('image/')) return { kind: 'image' }
  if (WORD_EXTENSIONS.has(ext)) return { refusal: `${file.name} is a Word file. Save it as a PDF and upload that.` }
  return { refusal: `${file.name} can't be imported. Use a PDF or a photo of the page.` }
}; exports.importKind = importKind

 const tooManyPages = (name, pages) =>
  `${name} has ${pages} pages. A form can have up to ${exports.MAX_PAGES}. Upload only the pages families fill in.`; exports.tooManyPages = tooManyPages

/* A photo the browser can't decode: most often a HEIC outside Safari. */
 const unreadablePhoto = (name) =>
  `${name} can't be opened in this browser. Save it as JPG and upload that.`; exports.unreadablePhoto = unreadablePhoto

 const unreadablePdf = (name) =>
  `${name} can't be opened. Save it again as a PDF and upload that.`; exports.unreadablePdf = unreadablePdf

/* The form's name: the file's name without its extension. */
 const formNameOf = (fileName) => fileName.replace(/\.[^.]+$/, '').trim(); exports.formNameOf = formNameOf

/* What pdf.js reports for a form widget (PDFPageProxy.getAnnotations). */




















const clamp01 = (n) => Math.min(1, Math.max(0, n))

/* A PDF rectangle (points, origin bottom left) as fractions of the page as it
 * is shown (origin top left), after the page's rotation. */
 const pdfRectToBox = (rect, view, rotate = 0) => {
  const [vx0 = 0, vy0 = 0, vx1 = 0, vy1 = 0] = view
  const [rx0 = 0, ry0 = 0, rx1 = 0, ry1 = 0] = rect
  const width = vx1 - vx0
  const height = vy1 - vy0
  const x = (Math.min(rx0, rx1) - vx0) / width
  const y = (vy1 - Math.max(ry0, ry1)) / height
  const w = Math.abs(rx1 - rx0) / width
  const h = Math.abs(ry1 - ry0) / height
  switch (((rotate % 360) + 360) % 360) {
    case 90: return { x: 1 - (y + h), y: x, w: h, h: w }
    case 180: return { x: 1 - (x + w), y: 1 - (y + h), w, h }
    case 270: return { x: y, y: 1 - (x + w), w: h, h: w }
    default: return { x, y, w, h }
  }
}; exports.pdfRectToBox = pdfRectToBox

const clampBox = ({ x, y, w, h }) => {
  const cx = clamp01(x)
  const cy = clamp01(y)
  const cw = Math.min(x + w, 1) - cx
  const ch = Math.min(y + h, 1) - cy
  return cw > 0 && ch > 0 ? { x: cx, y: cy, w: cw, h: ch } : null
}

const typeOf = (w) => {
  switch (w.fieldType) {
    case 'Tx': return 'text'
    case 'Ch': return 'choice'
    case 'Sig': return 'signature'
    case 'Btn':
      if (w.pushButton) return null
      return w.radioButton ? 'choice' : 'checkbox'
    default: return null
  }
}

const union = (a, b) => [
  Math.min(_nullishCoalesce(a[0], () => ( 0)), _nullishCoalesce(a[2], () => ( 0)), _nullishCoalesce(b[0], () => ( 0)), _nullishCoalesce(b[2], () => ( 0))),
  Math.min(_nullishCoalesce(a[1], () => ( 0)), _nullishCoalesce(a[3], () => ( 0)), _nullishCoalesce(b[1], () => ( 0)), _nullishCoalesce(b[3], () => ( 0))),
  Math.max(_nullishCoalesce(a[0], () => ( 0)), _nullishCoalesce(a[2], () => ( 0)), _nullishCoalesce(b[0], () => ( 0)), _nullishCoalesce(b[2], () => ( 0))),
  Math.max(_nullishCoalesce(a[1], () => ( 0)), _nullishCoalesce(a[3], () => ( 0)), _nullishCoalesce(b[1], () => ( 0)), _nullishCoalesce(b[3], () => ( 0))),
]

/* Each page's form widgets as fields the family fills, labelled with the
 * PDF's field name. A radio group becomes one choice over all its buttons;
 * push buttons are left out. */
 const widgetsToFields = (pages) => {
  const fields = []
  pages.forEach(({ widgets, view, rotate }, page) => {
    // A radio group is one entry, its rectangle growing as its buttons are found.
    const placed = []
    const radios = new Map()
    for (const w of widgets) {
      const type = w.subtype === 'Widget' ? typeOf(w) : null
      if (!type) continue
      const label = (_nullishCoalesce(w.fieldName, () => ( ''))).trim().slice(0, 200)
      if (w.fieldType === 'Btn' && w.radioButton) {
        const option = _nullishCoalesce(w.buttonValue, () => ( ''))
        const group = radios.get(label)
        if (group) {
          group.rect = union(group.rect, w.rect)
          if (option && !group.options.includes(option)) group.options.push(option)
        } else {
          const entry = { rect: w.rect, type, label, options: option ? [option] : [] }
          radios.set(label, entry)
          placed.push(entry)
        }
        continue
      }
      const options = type === 'choice'
        ? (_nullishCoalesce(w.options, () => ( []))).map(o => (o.displayValue || o.exportValue || '').trim()).filter(Boolean)
        : undefined
      placed.push({ rect: w.rect, type, label, options })
    }
    for (const p of placed) {
      const box = clampBox(exports.pdfRectToBox.call(void 0, p.rect, view, rotate))
      if (!box) continue
      fields.push({
        id: `pdf-${page + 1}-${fields.length + 1}`,
        page,
        box,
        type: p.type,
        label: p.label,
        filler: 'family',
        required: p.type === 'signature',
        source: 'pdf',
        ...(_optionalChain([p, 'access', _6 => _6.options, 'optionalAccess', _7 => _7.length]) ? { options: p.options.slice(0, 20) } : {}),
      })
    }
  })
  return fields.slice(0, MAX_FIELDS)
}; exports.widgetsToFields = widgetsToFields
